module.exports = __webpack_public_path__ + "static/media/bring-closer-smaller.c4cb9890.gif";